
export enum MapSettings {
  // eslint-disable-next-line no-magic-numbers
  MaxRadiusDistance = 15,
  // eslint-disable-next-line no-magic-numbers
  MaxRouteDistance = 3
}
